<template>
  <section id="product" v-bind:class="'kind-' + bike.gender.toLowerCase()">
    <div class="container">
      <div class="row">
        <carousel :activePage="currentPage" @update="pageChanged" :navigationEnabled="false">
          <slide :key="color_index" v-for="(color,color_index) in bike.colors">
            <div class="product-big" v-bind:style="getPhoto(color,'big')"></div>
          </slide>
        </carousel>
        <div id="product-data">
          <div class="inner-positioner">
            <div class="features" v-if="features.length > 0">
              <ul class="features-logos">
                <bike-features :f="feature" :key="index" v-for="(feature,index) in features"></bike-features>
              </ul>
            </div>
            <h1 class='model' v-html="$options.filters.bike_name(bike.name, bike.gender)"></h1>
            <div v-if="parseInt(bike.sell_price) > 0 && language == 'pl'" class="price"
                 v-html="$options.filters.integer_price(bike.sell_price)">

            </div>
            <installment-simulation :price="parseFloat(bike.sell_price)"/>
            <div v-translate="'available_colors'">Dostępne kolory</div>
            <ul class="color-switcher">
              <li :key="color_index"
                  v-for="(color,color_index) in bike.colors"
                  v-on:click="setActiveSlide(color_index)"
                  v-bind:class="{active: isCurrent(color_index)}">
                <div class="product-icon" v-bind:style="getPhoto(color,'icon')"></div>
                <p class="color-name">{{ color.color_name }}</p>
              </li>
            </ul>

            <!-- koła i biegi -->
            <div class='specs'>

              <div class="spec wheelsize">
                <span class='spec-label' v-translate="'bs_wheel_size'">Koła</span>
                <span class="circle">{{ parseInt(bike.wheel_size) }}</span>
              </div>

              <div class="spec gears">
                <span class="circle">{{ bike.gears }}</span>
                <span class='spec-label'>{{ gearsLabel }}</span>
              </div>

            </div>

            <div class="buttons-positioner">

              <div class="action-buttons" v-if="false && language == 'pl'">

                <div v-if="combinationSizes.length > 1"
                     class="btn fat" href="#"
                     v-on:click.stop="toggleSizes()"
                     v-bind:class="{'active': sizesVisible}">
                  <div>{{ cartButtonLabel }}</div>
                  <ul>
                    <li :key="size.SKU" v-for="size in combinationSizes" v-bind:title="size.SKU">
                      <a v-on:click="addToCart(size.SKU,parseInt(size.stock))"
                         :class="{'disabled' : parseInt(size.stock) === 0 }">{{ size.size }}</a>
                    </li>
                  </ul>
                </div>
                <a v-else class="btn fat"
                   v-on:click="addToCart(combinationSizes[0].SKU,parseInt(combinationSizes[0].stock) )"
                   :class="{'disabled' : parseInt(combinationSizes[0].stock) === 0 }">{{ cartButtonLabel }}</a>
                <a class="btn fat" :href="getRoute('dealers')" v-translate="'find_dealer'">Znajdź dealera</a>

              </div>

            </div>
            <div class="calculator" v-if="language == 'pl'">
              <installment-calculator :price="parseFloat(bike.sell_price)"/>
            </div>
          </div><!-- inner positioner -->
        </div><!-- bike data -->
      </div><!-- row -->
    </div><!-- container -->
    <serie-logo :serie="bike.group_name.toLowerCase()"/>

    <v-dialog/>

  </section>
</template>

<script>

  import $ from 'jquery'
  import _ from 'lodash'
  import store from "./../../store/index"
  import SerieLogo from './../Graphics/SerieLogo'
  import Carousel from './../Carousel/Carousel'
  import Slide from './../Carousel/Slide'
  import BikeFeatures from '../Graphics/BikeFeatures.vue'
  import InstallmentSimulation from "./InstallmentSimulation";
  import InstallmentCalculator from "./InstallmentCalculator";

  export default {
    name: 'bike',

    props: {
      model: String,
      color: String
    },
    components: {
      InstallmentCalculator,
      InstallmentSimulation,
      Carousel,
      Slide,
      SerieLogo,
      BikeFeatures

    },
    computed: {


      curentColorId: function () {
        return this.slidesIndex[this.currentPage]
      },
      cartButtonLabel: function () {
        return this.sizesVisible ? translations['ct_pick_size'] : translations['ct_cart_add']
      },

      combinationSizes: function () {
        return _.filter(this.bike.combinations, {'main_color': this.curentColorId})
      },

      gearsLabel: function () {
        let gears = parseInt(this.bike.gears);
        if (typeof (gears) === 'undefined') return ''; // brak liczby w stringu
        if (gears === 1) return translations['bs_gear'];// bieg
        let last = (gears % 10); // wybieranie istatniej cyfry
        if (last > 1 && last < 5) return translations['bs_gears24']; // biegi
        return translations['bs_gears'] // biegów
      }
    },

    created: function () {
      this.bike = _.find(window.env.data.bikes, {'internal_name': this.model});
      let that = this;
      let i = 0;
      _.forEach(that.bike.colors, function (el, key) {
        that.slidesIndex[i++] = key
      });

    },

    mounted() {
      let that = this;
      _.forEach(that.bike.colors, function (el, key) {

        if (el.main_color === that.color) {
          that.setActiveSlide(key);
          that.$bus.$emit('colorChanged', key)
        }
      });
      $.getJSON(env.baseUrl + 'data/features/' + this.bike.id, function (data) {
        that.features = data
      });

      // raty payu
      let price = parseFloat(this.bike.sell_price);
      if(this.installment && price >= 300 && price <= 20000) {

        window.openpayu.options = {
          creditAmount: price,  // wartość w PLN
          posId: '201815',         // identyfikator punktu płatności
          key: 'Lc',              // pierwsze dwa znaki klucza api
          showLongDescription: true
        };
        window.OpenPayU.Installments.miniInstallment('#installment-mini');

      }

    },

    data() {
      return {
        installment: false,
        slidesIndex: [0],
        currentPage: 0,
        bike: {},
        sizesVisible: false,
        features: {},
        language: window.env.language


      }
    }, // data

    methods: {
      getRoute(id) {
        let tid = 'rt_' + id;
        if (typeof window.translations[tid] !== 'undefined')
          return window.env.baseUrl + window.translations[tid];
        return "";
      },
      addToCart: function (sku, stock) {
        if (stock > 0) {

          let available = stock;
          if (typeof store.state.items != 'undefined') {
            let productInCart = store.state.items[sku];

            if (typeof productInCart != "undefined") {
              available -= productInCart.qty;
            }
          }

          if (available > 0) {
            this.$bus.$emit('addToCart', sku);
          } else {
            this.modal('Uwaga', 'Przekroczono dostępną ilość produktu.');
          }
        } else {
          this.modal('Uwaga', 'Produkt aktualnie niedostępny.');
        }
      },

      toggleSizes: function () {
        this.sizesVisible = !this.sizesVisible
      },

      setActiveSlide: function (slideId) {
        this.currentPage = this.slidesIndex.indexOf(slideId)
      },

      pageChanged: function (page) {
        this.currentPage = page;
        this.$bus.$emit('colorChanged', this.slidesIndex[this.currentPage])
      },

      isCurrent: function (slideId) {
        let slideIndex = this.slidesIndex.indexOf(slideId);
        return slideIndex === this.currentPage
      },

      getPhoto: function (color, style) {
        return 'background-image: url(\'' +
                env.baseUrl +
                'photos/styles/' + style + '/' +
                window.env.collection +
                '/bikes/legrand_' +
                color.photo_color + (color.is_glossy === '1' ? '_polysk' : '_mat') +
                '.png\');'
      },

      modal(title, message) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [{
            title: 'OK',
            default: true,
          },
          ]
        })
      }

    } // methods
  }
</script>



// WEBPACK FOOTER //
// src/components/Products/Bike.vue